/* eslint-disable */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { printHtml } from 'utils';
import { t } from 'utils/translates';
import ExecLinkPanel from './ExecLinkPanel';
import copyToClipboard from 'copy-to-clipboard';
import { addClientNotice } from 'mt-react-common/modules/main/reducers/static/states/clientNotices/reducer';
import { selectUserId } from 'mt-react-common/modules/users/common/reducers/states/authAccount';

class ExecDescBlock extends Component {
  copyToClipboard = value => {
    copyToClipboard(value);
    this.props.addClientNotice({
      type: 'success',
      message: 'Комментарий скопирован в буфер обмена'
    });
  };

  render() {
    const taskDesc = this.props.task.checkDesc.split('\n').map((item, key) => (
      <React.Fragment key={`TaskDescBlock${key + 1}`}>
        {printHtml(item)}
        <br />
      </React.Fragment>
    ));

    let desc = null;
    if (this.props.task.myLastExec) {
      if ([1, 3].includes(this.props.task.myLastExec.checkType)) {
        desc = taskDesc;
      } else {
        desc = <p>{this.props.task.myLastExec.quizAsk}</p>;
      }
    } else if ([1, 3].includes(this.props.task.checkTypeId)) {
      desc = taskDesc;
    } else {
      desc = (
        <p>
          {t(
            'Проверка осуществляется с помощью контрольного вопроса. Вопрос можно\n' +
              'будет увидеть после начала выполнения'
          )}
          .
        </p>
      );
    }
    return (
      <div>
        <article
          className="panel panel-heading_padding-large panel-default"
          id="desc"
        >
          <div className="panel-heading text-center panel-inner-border-bottom">
            <h2 className="panel-title">
              <i className="fa fa-info-circle" /> {t('Описание задачи')}
            </h2>
          </div>
          <div className="panel-body">
            {this.props.task.desc.split('\n').map((item, key) => (
              <span key={`TaskDescBlock${key + 1}`}>
                {item}
                <br />
              </span>
            ))}
          </div>
        </article>
        <article className="panel panel-heading_padding-large panel-default">
          <div className="panel-heading text-center panel-inner-border-bottom">
            <h2 className="panel-title">
              <i className="fa fa-check-circle-o" />{' '}
              {t('Подтверждение и проверка выполнения')}
            </h2>
          </div>
          <div className="panel-body">
            {desc}
            {this.props.task.reviewTask ? (
              <div className="form-group m-t-20">
                <label className="control-label" htmlFor="referalLink">
                  Скопируйте текст комментария:
                </label>
                <div className="input-group">
                  <input
                    readOnly="readonly"
                    type="text"
                    name="referalLink"
                    id="referalLink"
                    className="form-control"
                    value={this.props.task.reviewTask.comment}
                  />
                  <span className="input-group-btn">
                    <button
                      className="btn btn-default"
                      data-clipboard-target="#referalLink"
                      type="button"
                      onClick={() =>
                        this.copyToClipboard(this.props.task.reviewTask.comment)
                      }
                    >
                      <i className="fa fa-clipboard" />
                    </button>
                  </span>
                </div>
              </div>
            ) : (
              undefined
            )}
          </div>
        </article>
        {this.props.task.myLastExec ? (
          <ExecLinkPanel taskExec={this.props.task.myLastExec} />
        ) : null}
      </div>
    );
  }
}

ExecDescBlock.propTypes = {
  task: PropTypes.shape({
    desc: PropTypes.string.isRequired,
    checkTypeId: PropTypes.number,
    checkDesc: PropTypes.string.isRequired,
    reviewTask: PropTypes.shape({}),
    myLastExec: PropTypes.shape({
      checkType: PropTypes.number,
      quizAsk: PropTypes.string
    })
  }).isRequired,
  addClientNotice: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  authUserId: selectUserId(state)
});

const mapDispatchToProps = dispatch => ({
  addClientNotice: params => dispatch(addClientNotice(params))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ExecDescBlock));



// WEBPACK FOOTER //
// ./src/components/Tasks/_common/ExecDescBlock/ExecDescBlock.js